import apiClient from './axios';

/**
 * Career-related API services
 */
const careerService = {
  /**
   * Submit a job application
   * @param {Object} formData - The application form data
   * @param {string} formData.fullName - Applicant's full name
   * @param {string} formData.email - Applicant's email
   * @param {string} formData.phone_no - Applicant's phone number
   * @param {string} formData.address - Applicant's address
   * @param {string} formData.description - Application description/cover letter
   * @param {File} formData.resume - Applicant's resume file
   * @returns {Promise} - API response promise
   */
  applyForJob: async (formData) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!formData.fullName?.trim()) throw new Error('Name is required');
    if (!formData.email?.trim() || !emailRegex.test(formData.email)) throw new Error('Valid email is required');
    if (!formData.phone_no?.trim() || !phoneRegex.test(formData.phone_no.replace(/[\s-]/g, ''))) throw new Error('Valid 10-digit phone number is required');
    if (!formData.address?.trim()) throw new Error('Address is required');
    if (!formData.description?.trim()) throw new Error('Description is required');

    const data = new FormData();
    data.append('fullName', formData.fullName.trim());
    data.append('email', formData.email.trim());
    data.append('phone_no', formData.phone_no.trim());
    data.append('address', formData.address.trim());
    data.append('description', formData.description.trim());
    
    // Append resume file if available
    if (formData.resume) {
      data.append('resume', formData.resume);
    }

    // Use multipart/form-data for file uploads
    return apiClient.post('/api/admin/apply-now', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Get all career openings with pagination
   * @param {number} page - Page number (default: 1)
   * @param {number} perPage - Number of items per page (default: 10)
   * @returns {Promise} - API response promise
   */
  getAllCareers: async (page = 1, perPage = 10) => {
    return apiClient.get('/api/admin/get-all-career', {
      params: {
        page,
        perPage
      }
    });
  },
};

export default careerService;
